var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.81257 8.03137L16 15.1874L15.2503 15.9999L8 8.78108L0.812571 15.9999L0 15.1874L7.18743 8.03137L0 0.81251L0.812571 -6.10352e-05L8 7.2188L15.2503 -6.10352e-05L16 0.81251L8.81257 8.03137Z",
  fill: "white"
})));
export default SvgIconClose;